import { render, staticRenderFns } from "./PictureAndVideoList.vue?vue&type=template&id=32c15a85&scoped=true&"
import script from "./PictureAndVideoList.vue?vue&type=script&lang=js&"
export * from "./PictureAndVideoList.vue?vue&type=script&lang=js&"
import style0 from "./PictureAndVideoList.vue?vue&type=style&index=0&id=32c15a85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c15a85",
  null
  
)

export default component.exports